// Gouvernance — État du système (API, Mongo, Policy, Gatekeeper).
import { Server } from "lucide-react";
import { useGovernanceData } from "./useGovernanceFetch";

export default function GouvSystemHealthWidget() {
  const { data } = useGovernanceData();
  const policy = data.policy;
  const canDeploy = data.gatekeeper?.latest_scan?.can_deploy;

  return (
    <div className="p-5 rounded-xl bg-zinc-900/50 border border-zinc-800" data-testid="gouv-system-health-widget">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
        <Server className="w-5 h-5 text-cyan-400" />
        État du système
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        <Item label="API Backend" sub="Opérationnel" pulse="bg-emerald-400" />
        <Item label="MongoDB" sub="Connecté" pulse="bg-emerald-400" />
        <Item label="Policy Engine" sub={`Cache: ${policy?.cache_hash || "—"}`} pulse="bg-emerald-400" />
        <Item label="Gatekeeper" sub={canDeploy ? "Prêt" : "En attente"} pulse={canDeploy ? "bg-emerald-400" : "bg-yellow-400"} />
      </div>
    </div>
  );
}

function Item({ label, sub, pulse }) {
  return (
    <div className="flex items-center gap-3">
      <div className={`w-2 h-2 rounded-full ${pulse} animate-pulse`} />
      <div>
        <p className="text-sm font-medium text-white">{label}</p>
        <p className="text-xs text-zinc-500">{sub}</p>
      </div>
    </div>
  );
}
